import { text } from "../utils/i18n";

export class SignedOfferLink {
  /**
   * Optional IDs of one or more after-order work actions to grab a link from.
   * 
   * If multiple IDs are provided, then the link of the first action to be executed will be used.
   */
  readonly afterOrderWorkActionIds: string[] = [];
  readonly url?: string = null;
  readonly urlObject?: URL = null;
  readonly linkText?: string;
  /**
   * Whether the redirect is delayed to show the sign confirmation.
   */
  readonly isDelayedRedirect: boolean = true;
  readonly isAutomaticRedirect: boolean = false;

  /**
   * Optional message. Overrides the default message,
   */
  readonly message: string = text`Avtalet är signerat`;

  constructor(deriveFrom?: Partial<SignedOfferLink>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    this.urlObject = null;
    
    if (this.url) {
      try {
        this.urlObject = new URL(/^https?:\/\//.test(this.url) ? this.url : "https://" + this.url);
      } catch (error) {
        console.error(error);
      }
    }
  }
}

/**
 * Links for navigating away from an offer of a status other than Pending and Read (terminative statuses). 
 */
export class OfferStatusLinks {
  readonly signed: SignedOfferLink = new SignedOfferLink();
  readonly defaultUrl?: string;

  constructor(deriveFrom?: Partial<OfferStatusLinks>) {
    if (deriveFrom) {
      Object.assign(this, deriveFrom);
    }

    if (this.signed) {
      this.signed = new SignedOfferLink(this.signed);
    }
  }

  getDefaultUrl(): URL | null {
    let { defaultUrl, signed } = this;
    let signedUrl = signed?.url;

    try {
      if (defaultUrl && !/^https?:\/\//.test(defaultUrl)) {
        defaultUrl = 'https://' + defaultUrl;
      }

      if (defaultUrl) {
        return new URL(defaultUrl);
      }

      if (!signed?.afterOrderWorkActionIds.length) {
        //  Don't use a customer-specific link, created by an after-order work action.
        if (signedUrl && !/^https?:\/\//.test(signedUrl)) {
          signedUrl = 'https://' + signedUrl;
        }

        if (signedUrl) {
          const signedUrlObject = new URL(signedUrl);
          return new URL(signedUrlObject.origin);
        }
      }
    } catch (error) {
      console.error(error);
    }

    return null;
  }
}